export const API_NAME = "users";
export const ROUTE_NAME = "users";
export const COMPONENT_NAMES = ["users", "users"];
